import * as React from 'react';

import type {User} from 'nutshell-core/types';

import type {SidebarDrawerSection} from '../navigation/sidebar/sidebar';
import {OnboardingSidebarContent} from '../onboarding/onboarding-checklist/onboarding-sidebar-content';

import {NewSidebarNotifications} from './notifications/new-sidebar-notifications';
import {SidebarCalendar} from './sidebar-calendar';
import {SidebarCreateNew} from './sidebar-create-new';
import {SidebarSearch} from './sidebar-search';
import {SidebarUser} from './sidebar-user';
import {SlidingDrawer} from './sliding-drawer';

type Props = {
    activeSection: SidebarDrawerSection | null | undefined;
    user: User | null | undefined;
    closeSidebar: () => void;
    onClose: () => any;
    onOpen: () => void;
    isShortSidebar: boolean;
    isClosing: boolean;
    isOpening: boolean;
    isSidebarCollapsed?: boolean;
};

export class AnimatingSidebarDrawer extends React.PureComponent<Props> {
    myMenu: HTMLElement | null | undefined;

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        // Prevent scrolling the body when sidebar drawer is open.
        // Re-enable if the sidebar has been closed.
        if (this.props.activeSection !== nextProps.activeSection) {
            $('body').toggleClass('no-scroll', Boolean(nextProps.activeSection));
        }
    }

    render() {
        return (
            <SlidingDrawer
                isActive={Boolean(this.props.activeSection)}
                isClosing={this.props.isClosing}
                onOpen={this.props.onOpen}
                onClose={this.props.onClose}
                isWide={this.props.activeSection === 'onboarding'}
                isSidebarCollapsed={this.props.isSidebarCollapsed}
            >
                {this.props.activeSection === 'search' ? (
                    <SidebarSearch {...this.props} />
                ) : undefined}
                {this.props.activeSection === 'user' ? <SidebarUser {...this.props} /> : undefined}
                {this.props.activeSection === 'calendar' ? (
                    <SidebarCalendar
                        userId={this.props.user ? this.props.user.id : '1-users'}
                        closeSidebar={this.props.onClose}
                    />
                ) : undefined}
                {this.props.activeSection === 'onboarding' ? (
                    <OnboardingSidebarContent closeSidebar={this.props.onClose} />
                ) : undefined}
                <SidebarCreateNew
                    isActive={this.props.activeSection === 'create-new'}
                    {...this.props}
                />

                <NewSidebarNotifications
                    isActive={this.props.activeSection === 'notifications'}
                    closeSidebar={this.props.onClose}
                />
            </SlidingDrawer>
        );
    }
}
